import { Model } from './Model';

export class IPRange extends Model {
  public apiPath = undefined;
  public className = 'ipAddress';
  public minIPAddress?: string;
  public maxIPAddress?: string;
}
